import { Environment } from '../../env/Environment';
import { Typography } from '../primitives';
import { Trans } from '@rpi/i18n';
import React from 'react';

export enum TermsAndConditionsEnum {
  SIGNIN = 'terms_and_conditions_signin',
  SIGNUP = 'terms_and_conditions_signup',
}

interface TermsAndConditionsProps {
  termsEnum: TermsAndConditionsEnum;
}

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  termsEnum,
}) => {
  return (
    <Typography variant="footnote-2" className="text-center">
      <Trans
        i18nKey={'route.auth.' + termsEnum}
        components={{
          'terms-link': (
            <a
              aria-label="Terms Link"
              href={Environment.LINK.BLURB_TERMS}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
          'privacy-link': (
            <a
              aria-label="Privacy Link"
              href={Environment.LINK.BLURB_PRIVACY}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    </Typography>
  );
};
